import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import UserAction from '../../redux/UserActions';

import DataTable, {
    DataTableColumnProps,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import DistrictDTO from 'src/models/district/DistrictDTO';
import DistrictApiController from 'src/api/DistrictApiController';
import Button from 'antd/lib/button/button';
import { Tooltip, message } from 'antd';


interface DistrictsProps extends PageProps<{}>, LocalizeContextProps {
    emulateDistrict: (districtId: number) => Promise<boolean>;
}

interface DistrictsState {
    loading: boolean;
    tableRecords: DistrictDTO[];
    formRedirect: boolean;
}

class Districts extends React.Component<DistrictsProps, DistrictsState> {
    constructor(props: DistrictsProps) {
        super(props);
        bindAllOfThis(this, Districts.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private emulateDistrict(districtId: number) {
        return this.props.emulateDistrict(districtId).then(result => {
            if (!result) {
                message.error(this.props.translate("admin.common.messageEmulateError"));
                return;
            }
            // New user info should exist at this point, but props might not have updated yet. Push to home screen
            this.props.history.push(Routes.BASE_ROUTE); // Let login redirect them
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<DistrictDTO>) => void): void {
        this.setState({ loading: true });

        DistrictApiController.getDistrictTableData(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<DistrictDTO>[] {
        let editLink = (text, record: DistrictDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_DISTRICT, record.districtId);

        return [
            DataTable.StandardColumns.Text('admin.districts.columnHeader1', 'districtName'),
            {
                columnProps: {
                    key: 'emulate',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.emulateColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="user" onClick={() => this.emulateDistrict(record.districtId)} />
                            </Tooltip>
                        );
                    }
                }
            },
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.ADMIN_ADD_EDIT_DISTRICT} push />;
        }

        return (
            <div>
                <h2>{this.props.translate('admin.districts.tableHeader')}</h2>

                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'districtId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.districts.addButton', () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        emulateDistrict: (districtId: number) => UserAction.EmulateUser(dispatch, "district", districtId),
    });
}

export default connect(null, mapDispatchToProps)(withLocalize(Districts));



// WEBPACK FOOTER //
// ./src/pages/admin/Districts.tsx